import { gql } from "@apollo/client";

export const convertToPlan = gql`
  mutation convertToPlan($temp_plan_id: Int!) {
    convert_to_plan(temp_plan_id: $temp_plan_id) {
      id
    }
  }
`;
